import React from "react";
import ReactDOM from "react-dom/client";
import "./style/index.css";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/dates/styles.css";
import App from "./App.jsx";
import { localStorageColorSchemeManager, MantineProvider } from "@mantine/core";
import { RouterProvider } from "react-router-dom";
import routes from "@routes";
import { theme } from "./style/mantineTheme.js";
import { Notifications } from "@mantine/notifications";

const colorSchemeManager = localStorageColorSchemeManager({
	key: "my-apartment-color-scheme",
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<MantineProvider
			colorSchemeManager={colorSchemeManager}
			theme={theme}
			defaultColorScheme="light"
			cssVariablesSelector="html"
			withCssVariables
		>
			<Notifications position="bottom-left" />

			<RouterProvider router={routes}>
				<App />
			</RouterProvider>
		</MantineProvider>
	</React.StrictMode>
);

